import { render, staticRenderFns } from "./CarrierServices.vue?vue&type=template&id=15709a11&scoped=true"
import script from "./CarrierServices.vue?vue&type=script&lang=js"
export * from "./CarrierServices.vue?vue&type=script&lang=js"
import style0 from "./CarrierServices.vue?vue&type=style&index=0&id=15709a11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15709a11",
  null
  
)

export default component.exports